var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gameInstanceBox-container" },
    [
      _vm.gameInstanceBoxList.length > 0
        ? _c(
            "section",
            { staticClass: "gameInstanceBox-container-section" },
            _vm._l(_vm.gameInstanceBoxList, function (items, index) {
              return _c(
                "div",
                {
                  key: index,
                  ref: "caseloc" + index,
                  refInFor: true,
                  staticClass: "cases-item",
                },
                [
                  _c("c-case-item", {
                    staticClass: "fuben-item",
                    attrs: {
                      caseItem: items,
                      background: "#2c2f58",
                      showAbLeft: true,
                      showPrice: false,
                      showfubencishu: "zhanwei",
                    },
                    on: {
                      onShowCaseLeft: function ($event) {
                        _vm.notice_modal_show = true
                      },
                    },
                  }),
                  _vm._l(items.childList, function (case_item) {
                    return _c("c-case-item", {
                      key: case_item.caseId,
                      attrs: {
                        caseItem: case_item,
                        showPrice: false,
                        showfubencishu: "show",
                        accumulateCaseRoundCount:
                          case_item.accumulateCaseRoundCount,
                        accumulateCaseRate: case_item.accumulateCaseRate,
                      },
                      on: {
                        onCaseDetailHadle: function ($event) {
                          return _vm.onClickHandle($event, items, case_item)
                        },
                      },
                    })
                  }),
                ],
                2
              )
            }),
            0
          )
        : _vm._e(),
      _c("c-unpackgameInstance-item", {
        attrs: {
          type: "accumulate",
          gameInstanceId: _vm.unpackgameInstanceDetail.caseId,
          muxiangCaseId: _vm.muxiang_case_info.caseId,
        },
        on: { "on-sync": _vm.onSyncHandle },
        model: {
          value: _vm.unpackgameInstance_item_show,
          callback: function ($$v) {
            _vm.unpackgameInstance_item_show = $$v
          },
          expression: "unpackgameInstance_item_show",
        },
      }),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal notice-modal",
            "footer-hide": "",
            width: "'438rem'",
            closable: false,
          },
          model: {
            value: _vm.notice_modal_show,
            callback: function ($$v) {
              _vm.notice_modal_show = $$v
            },
            expression: "notice_modal_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "开箱概率说明", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.notice_modal_show = false
                },
              },
            },
            [
              _c("div", { staticClass: "text-content" }, [
                _c("p", [
                  _vm._v(" 每次开启盲盒为新的一轮"),
                  _c("span", [_vm._v("独立计算")]),
                  _vm._v(" ，多次开启盲盒并 "),
                  _c("span", [_vm._v("不意味")]),
                  _vm._v("着某区间"),
                  _c("span", [_vm._v("概率累加")]),
                  _vm._v(" 。 "),
                ]),
                _c("br"),
                _c("br"),
                _c("p", [_vm._v("举例1：")]),
                _c("p", [
                  _vm._v(" 盲盒内有A、B两件饰品,获得概率都为"),
                  _c("span", [_vm._v("50%")]),
                  _vm._v(",当连续开启该盲盒时, "),
                  _c("span", [_vm._v("无法保证")]),
                  _vm._v("开启结果"),
                  _c("span", [_vm._v("稳定")]),
                  _vm._v("为ABABAB "),
                ]),
                _c("br"),
                _c("br"),
                _c("p", [_vm._v("举例2：")]),
                _c("p", [
                  _vm._v(" 某饰品掉率为"),
                  _c("span", [_vm._v("10%")]),
                  _vm._v(", 当连续开启该盲盒时, "),
                  _c("span", [_vm._v("可能10次无掉落")]),
                  _vm._v("该饰品, 也可能20次掉落1次, "),
                  _c("span", [_vm._v("无法保证")]),
                  _vm._v("每开10次"),
                  _c("span", [_vm._v("必定掉落")]),
                  _vm._v("1次该饰品 "),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }